import React from "react"
import { LocalesContext } from "../../context/LocalesContext"
import {
	ScrollPanel,
	Flex,
	Text,
	INNER_MAX_WIDTH,
} from "@capioweb/ui-components"
import Property, {
	BooleanProperty,
	StringProperty,
} from "../../@types/EpiFoundationSpa/Property"
import {
	CapioNexusDiscoverBlock,
	CapioNexusDiscoverBlockProps,
} from "./CapioNexusDiscoverBlock"

interface CapioNexusDiscoverSectionBlockProps {
	heading: StringProperty
	description?: StringProperty
	mainContent: Property<CapioNexusDiscoverBlockProps[]>
	anchorId?: StringProperty
	marginBottom?: BooleanProperty
	whiteBackground?: BooleanProperty
}

const CapioNexusDiscoverSectionBlock: React.FC<CapioNexusDiscoverSectionBlockProps> =
	({ mainContent, anchorId, marginBottom, ...rest }) => {
		const slideRef = React.useRef(null)
		const { translate, translationKeys } = React.useContext(LocalesContext)
		const itemWidth = 36

		return (
			<Flex
				as="section"
				py={4}
				backgroundColor={!rest?.whiteBackground?.value && "greyF3"}
				id={anchorId?.value || null}
				mb={marginBottom?.value ? 3 : 0}
			>
				<Flex alignItems="center" flexDirection="column" w={1}>
					<Flex
						flexDirection="column"
						alignItems="center"
						px={3}
						maxw={69}
						m="0 auto"
					>
						{rest.heading?.value && (
							<Text as="h2" variant="headline-2" textAlign="center">
								{rest.heading.value}
							</Text>
						)}
						{rest.description?.value && (
							<Text textAlign="center">{rest.description.value}</Text>
						)}
					</Flex>
					{mainContent?.value?.length > 0 && (
						<ScrollPanel slideRef={slideRef}>
							<ScrollPanel.Content
								itemCount={mainContent.value.length}
								itemWidth={itemWidth}
							>
								<Flex
									pt={0.125}
									pb={1}
									pl={3}
									pr={1}
									w={1}
									maxw={INNER_MAX_WIDTH}
								>
									{mainContent.value.map((c, i) => (
										// padding is 8 or 16 - 2px for borders
										// minw is card width + padding
										<Flex
											minw={itemWidth}
											key={i}
											ref={i === 0 ? slideRef : null}
										>
											<CapioNexusDiscoverBlock
												{...c}
												borderColor={
													rest.whiteBackground.value ? "blue33" : "greyF3"
												}
											/>
										</Flex>
									))}
								</Flex>
							</ScrollPanel.Content>
							<ScrollPanel.Navigation
								locales={{
									nextButtonLabel: translate(translationKeys.next) || "",
									prevButtonLabel: translate(translationKeys.prev) || "",
								}}
							/>
						</ScrollPanel>
					)}
				</Flex>
			</Flex>
		)
	}

export { CapioNexusDiscoverSectionBlock }
